type Ratings = {
  good: number;
  neutral: number;
  poor: number;
  total: number;
};

export function percentages(
  ratings: Ratings | undefined,
): Omit<Ratings, "total"> | undefined {
  if (!ratings) return;

  if (ratings.total === 0) {
    return { good: 0, neutral: 0, poor: 0 };
  }

  return {
    good: Number(((ratings.good / ratings.total) * 100).toFixed(0)),
    neutral: Number(((ratings.neutral / ratings.total) * 100).toFixed(0)),
    poor: Number(((ratings.poor / ratings.total) * 100).toFixed(0)),
  };
}
